import { Box, useMediaQuery, useTheme } from "@mui/material";
import React, { ReactNode } from "react";

interface CustomPaperProps {
  children: ReactNode;
  borderColor?: boolean;
  backgroundColor?: string;
  marginBottom?: string;
  padding?: string;
  // Set false when the card is already inside another card (e.g. the pre-login QRC hub
  // shell), where the drop shadow reads as a card within a card.
  elevated?: boolean;
}
const defaultPadding = "15px 25px 25px 25px";
const Card = ({
  children,
  borderColor,
  backgroundColor = "white",
  marginBottom = "0px",
  padding = defaultPadding,
  elevated = true,
}: CustomPaperProps) => {
  const theme = useTheme();
  const isXsOrSm = useMediaQuery(theme.breakpoints.down("sm"));

  const appliedPadding = isXsOrSm ? "5px 10px 5px 10px" : padding;
  return (
    <Box
      sx={{
        width: "100%",
        padding: appliedPadding,
        gap: "15px",
        borderRadius: "6px",
        background: backgroundColor,
        boxShadow: elevated ? "0px 4px 18px 0px rgba(75, 70, 92, 0.1)" : "none",
        border: borderColor ? "1px solid rgba(0, 179, 181, 1)" : "none",
        marginBottom: marginBottom,
      }}
    >
      {children}
    </Box>
  );
};

export default Card;
